export class Vacation {
	readonly id: number;
	startTime: number;
	endTime: number;
	startDate: Date;
	endDate: Date;
	vacationType: VacationType;
	employeeId: number;
	notes: string;

	constructor(
		options: {
			startTime?: number;
			endTime?: number;
			startDate?: Date;
			endDate?: Date;
			vacationType?: VacationType;
			employeeId?: number;
			notes?: string;
		} = {}
	) {
		this.startTime = options.startTime || null;
		this.endTime = options.endTime || null;
		this.startDate = options.startDate || null;
		this.endDate = options.endDate || null;
		this.vacationType = options.vacationType || null;
		this.employeeId = options.employeeId || null;
		this.notes = options.notes || null;
	}
}

export class VacationType {
	readonly id: number;
	type: VacationTypeEnum;
	workingTimeAccountedFor: boolean;
}

export const enum VacationTypeEnum {
	Reunion = 'Réunion',
	Conges = 'Congés',
	Formation = 'Formation',
	Maladie = 'Maladie',
	Autre = 'Autre',
	Rdv_Professionnel = 'RDV Professionnel',
	Arret_Maladie = 'Arrêt maladie',
	RTT = 'RTT',
	Récupérations = 'Récupérations'
}
